
import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Calendar, Lock } from 'lucide-react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

interface Property {
  id: string;
  title: string;
  shortName?: string;
}

interface CalendarDayOptionsModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedDate: Date | null;
  selectedProperty: Property | null;
  isDateBlocked: boolean;
  onAddReservation: () => void;
  onBlockDate: () => void;
}

const CalendarDayOptionsModal = ({
  isOpen,
  onClose,
  selectedDate,
  selectedProperty,
  isDateBlocked,
  onAddReservation,
  onBlockDate,
}: CalendarDayOptionsModalProps) => {
  if (!selectedDate || !selectedProperty) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Opciones del Día</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          {/* Información del día seleccionado */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="font-medium text-gray-900">
              {format(selectedDate, 'EEEE, d MMMM yyyy', { locale: es })}
            </h3>
            <p className="text-sm text-gray-600 mt-1">
              {selectedProperty.shortName || selectedProperty.title}
            </p>
            {isDateBlocked && (
              <p className="text-sm text-red-600 mt-1 font-medium">
                ⚠️ Este día está actualmente bloqueado
              </p>
            )}
          </div>

          {/* Acciones disponibles */}
          <div className="space-y-3">
            <Button
              onClick={onAddReservation}
              className="w-full flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700"
            >
              <Calendar className="h-4 w-4" />
              Añadir Reserva
            </Button>

            <Button
              onClick={onBlockDate}
              variant="outline"
              className="w-full flex items-center justify-center gap-2 border-red-200 text-red-700 hover:bg-red-50"
            >
              <Lock className="h-4 w-4" />
              {isDateBlocked ? 'Desbloquear Día' : 'Bloquear Día'}
            </Button>
          </div>

          {/* Botón cancelar */}
          <Button
            onClick={onClose}
            variant="ghost"
            className="w-full"
          >
            Cancelar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CalendarDayOptionsModal;
